<script>
export default {
  name: "DashboardOverview",
  props: {
    config: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data: function () {
    return {
      loading: true,
      error: "",
      generatedAt: "",
      members: {
        total: 0,
        this_month: 0,
        change_pct: null,
        by_writer_type: {
          general: 0,
          associate: 0,
          provisional: 0,
          other: 0,
        },
      },
      applications: {
        today: 0,
        pending: 0,
        urgent: 0,
        unviewed_pending: 0,
        pending_overdue: 0,
        duplicate_name: 0,
        last_30_days: {
          total: 0,
          pending: 0,
          approved: 0,
          rejected: 0,
          incomplete: 0,
          duplicate: 0,
        },
      },
      successors: {
        total: 0,
        last_30_days: 0,
      },
      followups: [],
    };
  },
  computed: {
    memberSub: function () {
      if (this.loading) {
        return "กำลังโหลด";
      }
      var sub = "เดือนนี้ +" + this.fmtNum(this.members.this_month);
      if (this.members.change_pct !== null && this.members.change_pct !== undefined) {
        var pct = Number(this.members.change_pct);
        var sign = pct > 0 ? "+" : "";
        sub += " · " + sign + pct + "% จากเดือนที่แล้ว";
      }
      return sub;
    },
    appTodaySub: function () {
      if (this.loading) {
        return "กำลังโหลด";
      }
      return "รอตรวจสอบ " + this.fmtNum(this.applications.pending) + " รายการ";
    },
    successorSub: function () {
      if (this.loading) {
        return "กำลังโหลด";
      }
      return "เพิ่มใน 30 วัน: " + this.fmtNum(this.successors.last_30_days);
    },
    urgentSub: function () {
      if (this.loading) {
        return "กำลังโหลด";
      }
      return (
        "ยังไม่เปิดดู " +
        this.fmtNum(this.applications.unviewed_pending) +
        " · ค้างเกิน 2 วัน " +
        this.fmtNum(this.applications.pending_overdue)
      );
    },
    statusRows: function () {
      var last30 = this.applications.last_30_days || {};
      var total = Number(last30.total || 0);
      return [
        {
          label: "รอตรวจสอบ",
          cls: "bg-warning-subtle text-warning",
          count: Number(last30.pending || 0),
          href: "main-manage-application-member.php?page=application_pending_review",
        },
        {
          label: "ผ่านการพิจารณา",
          cls: "bg-success-subtle text-success",
          count: Number(last30.approved || 0),
          href: "main-manage-application-member.php?page=application_approved",
        },
        {
          label: "ไม่ผ่านการพิจารณา",
          cls: "bg-danger-subtle text-danger",
          count: Number(last30.rejected || 0),
          href: "main-manage-application-member.php?page=application_rejected",
        },
        {
          label: "ข้อมูลไม่ครบ",
          cls: "bg-secondary-subtle text-secondary",
          count: Number(last30.incomplete || 0),
          href: "main-manage-application-member.php?page=application_incomplete",
        },
        {
          label: "ใบสมัครซ้ำ",
          cls: "bg-info-subtle text-info",
          count: Number(last30.duplicate || 0),
          href: "main-manage-application-member.php?page=application_duplicate",
        },
      ].map(function (row) {
        row.pct = total > 0 ? Math.round((row.count / total) * 100) : 0;
        return row;
      });
    },
    statusNote: function () {
      var last30 = this.applications.last_30_days || {};
      return (
        "รวม " +
        this.fmtNum(last30.total) +
        " ใบใน 30 วัน · ทั้งระบบรอตรวจสอบ " +
        this.fmtNum(this.applications.pending) +
        " · ชื่อซ้ำ " +
        this.fmtNum(this.applications.duplicate_name) +
        " ราย"
      );
    },
    footerNote: function () {
      if (this.loading) {
        return "กำลังโหลดข้อมูลภาพรวมจากฐานข้อมูล";
      }
      var note = "ข้อมูลจากฐานข้อมูลจริง ใช้ติดตามงานทะเบียนและจำนวนสมาชิก";
      if (this.generatedAt) {
        note += " · อัปเดต " + this.fmtDate(this.generatedAt);
      }
      return note;
    },
    writer: function () {
      return this.members.by_writer_type || {};
    },
  },
  mounted: function () {
    this.load();
  },
  methods: {
    fmtNum: function (n) {
      return Number(n || 0).toLocaleString("th-TH");
    },
    fmtDate: function (raw) {
      var t = String(raw || "").trim();
      if (t === "") {
        return "-";
      }
      var d = new Date(t.replace(" ", "T"));
      if (isNaN(d.getTime())) {
        return t;
      }
      return d.toLocaleDateString("th-TH", { year: "numeric", month: "short", day: "numeric" });
    },
    followupLabel: function (item) {
      if (item.status === "incomplete") {
        return "ติดตามข้อมูลไม่ครบ";
      }
      if (item.status === "duplicate") {
        return "ตรวจสอบใบสมัครซ้ำ";
      }
      return "ตรวจสอบใบสมัคร";
    },
    followupWait: function (item) {
      return item.days_waiting > 0 ? item.days_waiting + " วัน" : "วันนี้";
    },
    followupHref: function (item) {
      return "main-manage-application-member.php?page=view_application_member&id=" + encodeURIComponent(item.id || "");
    },
    followupBadge: function (item) {
      if (item.urgent) {
        return { cls: "badge bg-danger-subtle text-danger", text: "เร่งด่วน" };
      }
      if (item.status === "incomplete") {
        return { cls: "badge bg-secondary-subtle text-secondary", text: "ข้อมูลไม่ครบ" };
      }
      if (item.status === "duplicate") {
        return { cls: "badge bg-info-subtle text-info", text: "ใบสมัครซ้ำ" };
      }
      if (!item.registry_viewed) {
        return { cls: "badge bg-warning-subtle text-warning", text: "ยังไม่เปิดดู" };
      }
      return { cls: "badge bg-warning-subtle text-warning", text: "รอตรวจสอบ" };
    },
    load: function () {
      var self = this;
      var apiUrl = String((this.config && this.config.apiUrl) || "").trim();
      if (apiUrl === "") {
        this.loading = false;
        this.error = "ไม่พบที่อยู่ API ของ Dashboard";
        return;
      }
      fetch(apiUrl, { headers: { Accept: "application/json" }, credentials: "same-origin" })
        .then(function (res) {
          return res.json();
        })
        .then(function (json) {
          if (!json || json.success !== true) {
            throw new Error(json && json.message ? json.message : "โหลดข้อมูลไม่สำเร็จ");
          }
          self.members = Object.assign({}, self.members, json.members || {});
          self.applications = Object.assign({}, self.applications, json.applications || {});
          self.successors = Object.assign({}, self.successors, json.successors || {});
          self.followups = json.followups || [];
          self.generatedAt = json.generated_at || "";
          self.loading = false;
        })
        .catch(function (err) {
          self.loading = false;
          self.error = err && err.message ? err.message : "ไม่สามารถโหลด Dashboard ได้";
        });
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-sm-flex align-items-center justify-content-between bg-galaxy-transparent">
          <h4 class="mb-sm-0">Dashboard ภาพรวม</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript:void(0);">MCT.Member.Portal</a></li>
              <li class="breadcrumb-item active">Dashboard</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div v-if="error" class="alert alert-danger" role="alert">{{ error }}</div>

    <div class="row g-3 mb-3">
      <div class="col-md-6 col-xl-3">
        <a href="main-manage-member.php?page=member_list_all" class="text-decoration-none text-reset">
          <div class="card card-animate h-100">
            <div class="card-body">
              <p class="text-uppercase fw-medium text-muted mb-1">สมาชิกทั้งหมด</p>
              <h3 class="mb-0">{{ loading ? "—" : fmtNum(members.total) }}</h3>
              <small class="text-muted">{{ memberSub }}</small>
            </div>
          </div>
        </a>
      </div>
      <div class="col-md-6 col-xl-3">
        <a href="main-manage-application-member.php?page=application_pending_review" class="text-decoration-none text-reset">
          <div class="card card-animate h-100">
            <div class="card-body">
              <p class="text-uppercase fw-medium text-muted mb-1">ใบสมัครใหม่วันนี้</p>
              <h3 class="mb-0">{{ loading ? "—" : fmtNum(applications.today) }}</h3>
              <small class="text-muted">{{ appTodaySub }}</small>
            </div>
          </div>
        </a>
      </div>
      <div class="col-md-6 col-xl-3">
        <a href="main-manage-member.php?page=successor_list_all" class="text-decoration-none text-reset">
          <div class="card card-animate h-100">
            <div class="card-body">
              <p class="text-uppercase fw-medium text-muted mb-1">ผู้มีสิทธิ (ทายาท)</p>
              <h3 class="mb-0">{{ loading ? "—" : fmtNum(successors.total) }}</h3>
              <small class="text-muted">{{ successorSub }}</small>
            </div>
          </div>
        </a>
      </div>
      <div class="col-md-6 col-xl-3">
        <a href="main-manage-application-member.php?page=application_pending_review" class="text-decoration-none text-reset">
          <div class="card card-animate h-100">
            <div class="card-body">
              <p class="text-uppercase fw-medium text-muted mb-1">รายการเร่งด่วน</p>
              <h3 class="mb-0 text-danger">{{ loading ? "—" : fmtNum(applications.urgent) }}</h3>
              <small class="text-muted">{{ urgentSub }}</small>
            </div>
          </div>
        </a>
      </div>
    </div>

    <div class="row g-3 mb-3">
      <div class="col-xl-8">
        <div class="card h-100">
          <div class="card-header d-flex align-items-center justify-content-between">
            <h4 class="card-title mb-0">สถานะใบสมัคร (30 วันล่าสุด)</h4>
            <a href="main-manage-application-member.php?page=application_list_all" class="btn btn-sm btn-soft-secondary">ดูทั้งหมด</a>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-sm align-middle mb-0">
                <thead class="table-light">
                  <tr>
                    <th>สถานะ</th>
                    <th class="text-end">จำนวน</th>
                    <th style="min-width:140px;">สัดส่วน</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="loading">
                    <td colspan="3" class="text-muted">กำลังโหลด...</td>
                  </tr>
                  <tr v-for="row in statusRows" v-else :key="row.label">
                    <td>
                      <a class="text-decoration-none" :href="row.href">
                        <span class="badge" :class="row.cls">{{ row.label }}</span>
                      </a>
                    </td>
                    <td class="text-end">{{ fmtNum(row.count) }}</td>
                    <td>
                      <div class="d-flex align-items-center gap-2">
                        <div class="progress flex-grow-1" style="height:6px;">
                          <div class="progress-bar" role="progressbar" :style="{ width: row.pct + '%' }"></div>
                        </div>
                        <span class="small text-muted" style="min-width:2.5rem;">{{ row.pct }}%</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="small text-muted mt-3">{{ loading ? "" : statusNote }}</div>
          </div>
        </div>
      </div>
      <div class="col-xl-4">
        <div class="card h-100">
          <div class="card-header">
            <h4 class="card-title mb-0">ทางลัด</h4>
          </div>
          <div class="card-body d-grid gap-2">
            <a href="main-manage-member.php?page=member_add" class="btn btn-primary">+ เพิ่มสมาชิกใหม่</a>
            <a href="main-manage-member.php?page=successor_add" class="btn btn-soft-primary">+ เพิ่มผู้มีสิทธิ (ทายาท)</a>
            <a href="main-manage-application-member.php?page=application_pending_review" class="btn btn-soft-warning">ตรวจสอบใบสมัครค้าง</a>
            <a href="main-manage-application-member.php?page=application_incomplete" class="btn btn-soft-secondary">ใบสมัครข้อมูลไม่ครบ</a>
            <a href="main-manage-member.php?page=member_list_all" class="btn btn-light">ดูรายการสมาชิกทั้งหมด</a>
          </div>
        </div>
      </div>
    </div>

    <div class="row g-3">
      <div class="col-xl-6">
        <div class="card h-100">
          <div class="card-header d-flex align-items-center justify-content-between">
            <h4 class="card-title mb-0">รายการที่ต้องติดตาม</h4>
            <a href="main-manage-application-member.php?page=application_pending_review" class="small">เปิดคิวรอตรวจสอบ</a>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table align-middle mb-0">
                <thead class="table-light">
                  <tr>
                    <th>งาน</th>
                    <th>รอมาแล้ว</th>
                    <th class="text-center">สถานะ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="loading">
                    <td colspan="3" class="text-muted">กำลังโหลด...</td>
                  </tr>
                  <tr v-else-if="followups.length === 0">
                    <td colspan="3" class="text-muted">ไม่มีรายการค้างในขณะนี้</td>
                  </tr>
                  <tr v-for="item in followups" v-else :key="item.id">
                    <td>
                      <a :href="followupHref(item)" class="text-decoration-none">
                        <div class="fw-medium">{{ followupLabel(item) }} {{ item.application_no || "-" }}</div>
                        <div class="small text-muted">{{ item.name || "-" }} · {{ fmtDate(item.created_at) }}</div>
                      </a>
                    </td>
                    <td>{{ followupWait(item) }}</td>
                    <td class="text-center">
                      <span :class="followupBadge(item).cls">{{ followupBadge(item).text }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-6">
        <div class="card h-100">
          <div class="card-header">
            <h4 class="card-title mb-0">สรุปประเภทสมาชิก</h4>
          </div>
          <div class="card-body">
            <a href="main-manage-member.php?page=member_list_all" class="d-flex justify-content-between align-items-center border rounded p-3 mb-2 text-decoration-none text-reset">
              <div>
                <h6 class="mb-1">General Member</h6>
                <small class="text-muted">สมาชิกทั่วไป</small>
              </div>
              <span class="badge bg-primary-subtle text-primary fs-6">{{ fmtNum(writer.general) }}</span>
            </a>
            <a href="main-manage-member.php?page=member_list_all" class="d-flex justify-content-between align-items-center border rounded p-3 mb-2 text-decoration-none text-reset">
              <div>
                <h6 class="mb-1">Associate Member</h6>
                <small class="text-muted">สมาชิกสมทบ</small>
              </div>
              <span class="badge bg-success-subtle text-success fs-6">{{ fmtNum(writer.associate) }}</span>
            </a>
            <a href="main-manage-member.php?page=member_list_all" class="d-flex justify-content-between align-items-center border rounded p-3 mb-2 text-decoration-none text-reset">
              <div>
                <h6 class="mb-1">Provisional Member</h6>
                <small class="text-muted">สมาชิกชั่วคราว</small>
              </div>
              <span class="badge bg-warning-subtle text-warning fs-6">{{ fmtNum(writer.provisional) }}</span>
            </a>
            <div class="d-flex justify-content-between align-items-center border rounded p-3 mb-2">
              <div>
                <h6 class="mb-1">อื่น ๆ / ไม่ระบุ</h6>
                <small class="text-muted">ยังไม่ได้จัดประเภท</small>
              </div>
              <span class="badge bg-light text-muted fs-6">{{ fmtNum(writer.other) }}</span>
            </div>
            <div class="alert alert-info mb-0 mt-3" role="alert">{{ footerNote }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
